'use client'

import React, { createContext, useContext, useState, type ReactNode } from 'react';

interface ModalInquiryContextProps {
	children: ReactNode;
}

interface ModalInquiryContextValue {
	isModalOpen: boolean;
	openModalInquiry: () => void;
	closeModalInquiry: () => void;
}

const ModalInquiryContext = createContext<ModalInquiryContextValue | undefined>(undefined);

export const useModalInquiryContext = (): ModalInquiryContextValue => {
	const context = useContext(ModalInquiryContext);
	if (!context) {
		throw new Error('useModalInquiryContext must be used within a ModalSearchProvider');
	}
	return context;
};

export const ModalInquiryProvider: React.FC<ModalInquiryContextProps> = ({ children }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModalInquiry = () => {
		setIsModalOpen(true);
	};

	const closeModalInquiry = () => {
		setIsModalOpen(false);
	};

	const contextValue: ModalInquiryContextValue = {
		isModalOpen,
		openModalInquiry,
		closeModalInquiry,
	};

	return (
		<ModalInquiryContext.Provider value={contextValue}>
			{children}
		</ModalInquiryContext.Provider>
	);
};
